<template>
  <div class="is-fullheight">
    <div id="myearth">
      
    </div>

    <div>
      <img
        @load="loadScenario"
        id="hologram-map"
        src="@/assets/hologram-map-2.svg"
      />
    </div>
    <!--res-->
  </div>
</template>

<script>
export default {
  data: () => ({
    myearth: null,
    sunAngle: 0,
    overlays: [],
    connections: [
    ]
  }),
  methods: {
    loadScenario: function() {
      let self = this
      this.$loadScript('/miniatureEarth.js')
        .then(() => {
          self.initAnimation()
        })
        .catch(() => {
          console.log('Error')
        })
    },
    initAnimation: function() {
      let self = this
      self.myearth = new Earth(document.getElementById('myearth'), {
        light: 'none',

        texture: 'hologram-map',
        transparent: true,
        quality: 3,

        location: { lat: 23, lng: 0 },

        autoRotate: true,
        autoRotateSpeed: 1.2,
        autoRotateDelay: 100,
        autoRotateStart: 2000
      })

      self.myearth.addEventListener('ready', function() {
        this.startAutoRotate()
        document.getElementById('hologram-map').remove()


        var overlay = {
          transform: 'translate(-50%, -50%)',
          className: 'pulse-overlay',
          depthScale: 0.2,
          offset: -0.3
        }

        self.overlays[0] = this.addOverlay(overlay)
        self.overlays[1] = this.addOverlay(overlay)
        self.overlays[2] = this.addOverlay(overlay)
        self.overlays[3] = this.addOverlay(overlay)


      })
    },
  }
}
</script>

<style scoped>
#myearth.earth-ready {
  transition: filter 1s ease, background 1s;
}

#myearth::before {
  content: none;
}
#myearth {
  width: 100%;
  height: 100%;
}

#glow {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 940px;
  height: 940px;
  transform: translate(-50%, -50%);
  background: radial-gradient(
    ellipse at center,
    #9dd9e500 33%,
    #9dd9e511 38.5%,
    #bef4ff33 51.75%,
    #9dd9e500 70%
  );
  z-index: 100;
  pointer-events: none;
}

#res {
  width: 0;
  height: 0;
  overflow: hidden;
}

div.animation-content {
  transform: none;
  transition: 0;
}
</style>
